// A'gong Why Trust — scroll-triggered entrance animations
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-trust]')) return;

  if (!window.IntersectionObserver) {
    // Fallback: show everything immediately
    document.querySelectorAll(
      '[data-agong-trust-animate], .agong-trust__card, [data-agong-trust-solution]'
    ).forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  // Header
  document.querySelectorAll('[data-agong-trust-animate]').forEach(function (el) {
    observer.observe(el);
  });

  // Problem cards
  document.querySelectorAll('[data-agong-trust-cards] .agong-trust__card').forEach(function (el) {
    observer.observe(el);
  });

  // Solution — slightly later threshold so it pops in when fully visible
  var solutionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        solutionObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-agong-trust-solution]').forEach(function (el) {
    solutionObserver.observe(el);
  });
});
